import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import FileChanges from "../filesDiff/FileChanges";
const FileChangesTab = () => (React.createElement(ErrorBoundary, { key: "fileChanges" },
    React.createElement(FileChanges, null)));
export default FileChangesTab;
//# sourceMappingURL=FileChangesTab.js.map